import cs from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { usePreviewTemplate } from '../../contexts/PreviewTemplateContext';
import { PreviewHeader } from './PreviewHeader/PreviewHeader';
import { TemplateSaved } from './TemplateSaved/TemplateSaved';
import { TemplateDemoPreview } from './TemplateDemoPreview/TemplateDemoPreview';
import { templatePreviewModalDataHooks } from './TemplatePreviewModal.dataHooks';
import s from './TemplatePreviewModal.scss';

export const TemplatePreviewModal: FC = () => {
  const {
    previewTemplate,
    setIsSavedTemplate,
    setPreviewTemplate,
    isSavedTemplate,
  } = usePreviewTemplate();
  const biLogger = useBiLogger();
  const [isAppear, setIsAppear] = useState(false);

  useEffect(() => {
    if (previewTemplate) {
      setIsAppear(true);
      document.querySelector('body')!.className = s.rmScroll;

      biLogger.reportViewTemplate({
        templateId: previewTemplate.templateId,
        slug: previewTemplate.slug,
      });
    }

    return () => {
      setIsAppear(false);
      document.querySelector('body')!.className = '';
    };
  }, [previewTemplate]);

  const onSaveTemplateButtonClick = () => {
    biLogger.reportGeneralAction({
      action: 'save_template',
      templateId: previewTemplate?.templateId,
    });
    setIsSavedTemplate(true);
  };

  const onCloseButtonClick = () => {
    biLogger.reportGeneralAction({
      action: 'close_template_saved',
      templateId: previewTemplate?.templateId,
    });
    setIsSavedTemplate(false);
  };

  const onBrowseMoreTemplatesButtonClick = () => {
    biLogger.reportGeneralAction({
      action: 'browse_more_templates',
      templateId: previewTemplate?.templateId,
    });
    setPreviewTemplate(null);
    setIsSavedTemplate(false);
  };

  if (!previewTemplate) {
    return null;
  }

  return (
    <div
      data-hook={templatePreviewModalDataHooks.container()}
      className={cs(s.templatePreviewModal, {
        [s.appear]: isAppear,
      })}
    >
      {isSavedTemplate ? (
        <TemplateSaved
          onCloseClick={onCloseButtonClick}
          onButtonClick={onBrowseMoreTemplatesButtonClick}
          savedTemplate={previewTemplate}
        />
      ) : (
        <div className={s.previewBox}>
          <PreviewHeader onButtonClick={onSaveTemplateButtonClick} />
          <TemplateDemoPreview template={previewTemplate} />
        </div>
      )}
    </div>
  );
};
